/* eslint-disable max-lines-per-function */
import { createSelector } from '@ngrx/store';

import { MakeRef } from '../types';
import { createActionsWithReducer } from '../utils';
import { SingleEntityActions } from './actions';
import { createSingleEntityAdapter } from './adapter';
import {
  NotNull,
  SingleEntityState,
  SingleEntityStoreCustomActions,
  SingleEntityStoreOptions,
} from './types';

export function createSingleEntityStore<Entity extends object | null>() {
  return <StoreOptions extends SingleEntityStoreOptions<Entity>>(
    namespace: string,
    options?: StoreOptions,
  ) => {
    const ns = `entity/${namespace}`;

    const baseSelector = createSelector(
      (root: any) => <SingleEntityState<Entity>>root[ns],
      state => state,
    );

    const makeRef: MakeRef<NotNull<Entity>> = (mapFrom, mapTo, source) => ({
      mapFrom,
      mapTo,
      source,
    });
    const {
      adapter,
      initialState: defaultInitialState,
      selectors,
      defaultActionsConfig,
    } = createSingleEntityAdapter<Entity>(baseSelector, ns, options?.references?.(makeRef) || []);

    const mergedActions = <
      SingleEntityActions<Entity> & SingleEntityStoreCustomActions<StoreOptions>
    >{
      ...defaultActionsConfig,
      ...(<SingleEntityStoreCustomActions<StoreOptions>>(options?.customActions?.(adapter) || {})),
    };

    const { actions, reducer } = createActionsWithReducer(
      namespace,
      options?.initialState || defaultInitialState,
      mergedActions,
    );
    return {
      namespace: ns,
      selectors,
      actions,
      reducer,
    };
  };
}
